import { Card, CardContent, Label, Switch } from '@folio/components';
import { Group } from '@folio/components/ui/flex';

export interface DocumentsValidationSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  label: string;
  standalone?: boolean;
}

export function DocumentsValidationSwitch({
  checked,
  onCheckedChange,
  disabled,
  label,
  standalone = false,
}: DocumentsValidationSwitchProps) {
  const control = (
    <Group gap={2.5} className="flex-shrink-0">
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        id="document-validation"
      />
      <Label htmlFor="document-validation" className="text-sm font-normal whitespace-nowrap">
        {label}
      </Label>
    </Group>
  );

  if (!standalone) return control;

  return (
    <Card>
      <CardContent className="pt-6">{control}</CardContent>
    </Card>
  );
}
